import { Component, h } from "preact";
import Uploader from "../../uploader";
import {
  IReactConfiguration,
  ILabelOptionValue,
  IOption,
} from "../../../typings";
import EventController from "../../../shared/controller/event-controller";
import OutputController from "../../../shared/controller/output-controller";
import TemplateController from "../../../shared/controller/template-controller";
import UnitSystemController from "../../../shared/controller/unit-system-controller";
import LabelSvgSprite from "../../label-uploader/label-svg-sprite";

export default class RadioComponent extends Component<
  ILabelCordComponentProps,
  ILabelCordComponentState
> {
  constructor(props: ILabelCordComponentProps) {
    super(props);

    this.setValue = this.setValue.bind(this);
  }

  componentDidMount(): void {
    const value: string = this.props.outputController.getValue([
      "label",
      this.getOptionCode(),
    ]);
    this.setState({
      value,
    });

    const eventName: string = EventController.getSaveEventName([
      "label",
      this.getOptionCode(),
    ]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const value: string = this.props.outputController.getValue([
          "label",
          this.getOptionCode(),
        ]);
        this.setState({
          value,
        });
      });
  }

  setValue(e: any): void {
    const target: HTMLElement = e.currentTarget;
    const value: string = target.getAttribute("data-value");

    this.props.outputController.setValue(
      ["label", this.getOptionCode()],
      value,
    );
  }

  private getOptionCode(): string {
    return this.props.option.code;
  }

  render(): JSX.Element {
    return (
      <div className="flex">
        {this.props.option.values.map(
          (value: ILabelOptionValue, index: number) => (
            <div
              key={index}
              className={
                "w-1/2 flex flex-col justify-center items-center cursor-pointer hover:bg-gray-light rounded-md p-4 " +
                (this.state.value === value.value
                  ? "bg-blue-lighter border-blue border border-solid"
                  : "")
              }
              onClick={this.setValue}
              data-value={value.value}
              aria-label={value.meta.description}
              title={value.meta.description}
            >
              {value.attributes?.icon?.key && (
                <LabelSvgSprite
                  cssClass={
                    this.props.option?.attributes?.iconCss?.value
                      ? this.props.option.attributes.iconCss.value
                      : "h-14"
                  }
                  multicolorImage
                  viewBox="0 0 64 64"
                  conf={this.props.conf}
                  imageCode={value.attributes.icon?.value}
                />
              )}
              <span className="select-none">{value.meta.name}</span>
            </div>
          ),
        )}
      </div>
    );
  }
}

interface ILabelCordComponentProps {
  main: Uploader;
  conf: IReactConfiguration;
  option: IOption;

  eventController: EventController;
  outputController: OutputController;
  templateController: TemplateController;
  unitSystemController: UnitSystemController;
}

interface ILabelCordComponentState {
  value: any;
}
